import React from 'react';
import PropTypes from 'prop-types';

import { Button, DialogActions } from '@otcmarketsgroup/otcm-ui-lib';

const Controls = ({
  hideCancel = false,
  showSubmit = true,
  cancelText,
  size,
  isSubmitDisabled = false,
  isLoading = false,
  isSubmitSuccess,
  submitText,
  onCancelClick,
  onSubmitClick
}) => {
  return <DialogActions display='flex' gap={2}>
    {!hideCancel && <Button
      variant='outlined'
      fullWidth
      size={size}
      onClick={onCancelClick}>
      {cancelText || 'Cancel'}
    </Button>}
    {showSubmit && <Button
      fullWidth
      size={size}
      isLoading={isLoading}
      disabled={!isSubmitSuccess && (isSubmitDisabled || isLoading)}
      onClick={!isSubmitSuccess ? onSubmitClick : undefined}>
      {submitText || 'Save'}
    </Button>}
  </DialogActions>;
};

Controls.propTypes = {
  hideCancel: PropTypes.bool,
  showSubmit: PropTypes.bool,
  cancelText: PropTypes.string,
  submitText: PropTypes.string,
  onCancelClick: PropTypes.func,
  onSubmitClick: PropTypes.func,
  isSubmitDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  isSubmitSuccess: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
};

export default Controls;
